import { render, staticRenderFns } from "./StandardPagination.view.vue?vue&type=template&id=5d3efe98&"
import script from "./StandardPagination.view.vue?vue&type=script&lang=js&"
export * from "./StandardPagination.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d3efe98')) {
      api.createRecord('5d3efe98', component.options)
    } else {
      api.reload('5d3efe98', component.options)
    }
    module.hot.accept("./StandardPagination.view.vue?vue&type=template&id=5d3efe98&", function () {
      api.rerender('5d3efe98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/core/views/layouts/common/StandardPagination.view.vue"
export default component.exports